import request from 'utils/request';

const PREFIX = '/api/business-finance/';

export const CompanyInfoApi = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  UPDATE: PREFIX + 'update',
  DELETE: PREFIX + 'delete/',
  COMPANY_BANK_ADV_OPTIONS: PREFIX + 'company-bank/adv/options',
  COMPANY_BANK_AFF_OPTIONS: PREFIX + 'company-bank/aff/options',
  COMPANY_BANK_HYPER_TAP_OPTIONS: PREFIX + 'hyper-tap/company-info',
};

export function getCompanyBankAdvOption() {
  return request({
    url: CompanyInfoApi.COMPANY_BANK_ADV_OPTIONS,
    method: 'get',
  });
}
export function getCompanyBankAffOption() {
  return request({
    url: CompanyInfoApi.COMPANY_BANK_AFF_OPTIONS,
    method: 'get',
  });
}
export function getCompanyBankHyperTapOption() {
  return request({
    url: CompanyInfoApi.COMPANY_BANK_HYPER_TAP_OPTIONS,
    method: 'get',
  });
}

export function getCompanyInfoList(data) {
  return request({
    url: CompanyInfoApi.LIST,
    method: 'post',
    data,
  });
}

export function addCompanyInfo(data) {
  return request({
    url: CompanyInfoApi.ADD,
    method: 'post',
    data,
  });
}

export function deleteCompanyInfoById(id) {
  return request({
    url: CompanyInfoApi.DELETE + id,
    method: 'delete',
  });
}

export function updateCompanyInfo(data) {
  return request({
    url: CompanyInfoApi.UPDATE,
    method: 'put',
    data,
  });
}
